import { render, staticRenderFns } from "./RationsTableRowBody.vue?vue&type=template&id=6a00953e&lang=pug"
import script from "./RationsTableRowBody.vue?vue&type=script&lang=js"
export * from "./RationsTableRowBody.vue?vue&type=script&lang=js"
import style0 from "./RationsTableRowBody.vue?vue&type=style&index=0&id=6a00953e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports